import { Box } from "@mui/material";
interface IProps {
  videoUrl: string;
}
const RenderVideoBanner: React.FC<IProps> = ({ videoUrl }) => {
  const extractYouTubeId = (url: string) => {
    const youtubeRegex =
      /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(youtubeRegex);
    return match ? match[1] : null;
  };

  const isYouTubeUrl = (url: string) => {
    return url
      ? url.includes("youtube.com") || url.includes("youtu.be")
      : false;
  };

  const renderVideo = (videoUrl: string) => {
    if (isYouTubeUrl(videoUrl)) {
      const videoId = extractYouTubeId(videoUrl);
      return (
        <Box
          sx={{
            overflow: "hidden",
            width: "100%",
            height: "100%",
            aspectRatio: "16/9",
            pointerEvents: "none",
          }}
          id="render_video_banner_youtube_container"
          data-test-id="render_video_banner_youtube_container"
          aria-label="YouTube Video Container"
        >
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?controls=0&showinfo=0&rel=0&modestbranding=1&autohide=1&loop=1&autoplay=1&mute=1&playlist=${videoId}&fs=0&disablekb=1&iv_load_policy=3`}
            title="YouTube video player"
            allow="autoplay; encrypted-media"
            allowFullScreen
            style={{
              width: "100%",
              height: "100%",
              // marginLeft: "-100%",
            }}
            id="render_video_banner_youtube_iframe"
            data-test-id="render_video_banner_youtube_iframe"
            aria-label="YouTube Video Player"
          ></iframe>
        </Box>
      );
    } else {
      return (
        <video
          width="250"
          height="250"
          autoPlay
          muted
          loop
          disablePictureInPicture
          id="render_video_banner_video"
          data-test-id="render_video_banner_video"
          aria-label="Video Banner"
        >
          <source type="video/mp4" src={videoUrl as string} />
        </video>
      );
    }
  };

  return renderVideo(videoUrl);
};

export default RenderVideoBanner;
